import React from "react";

//MUI
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import LowPriorityIcon from "@mui/icons-material/LowPriority";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

// UTILS
import { trimEllip } from "../utility/utils";

type Props = {
  msg: string;
  limit?: number;
  isExploratory?: boolean;
  isDropped?: boolean;
  priority?: string;
};

const LongMsg = ({
  msg,
  limit = 30,
  isExploratory = false,
  isDropped = false,
  priority,
}: Props) => {
  const lowerCasePriority = priority ? priority.toLowerCase() : null;

  const getPriorityIcon = (lowerCasePriority: string) => {
    if (lowerCasePriority === "low") {
      return <LowPriorityIcon />;
    } else if (lowerCasePriority === "high") {
      return <PriorityHighIcon />;
    } else {
      return null;
    }
  };
  return (
    <>
      <Tooltip title={msg} placement="top-start" arrow>
        <span>
          {trimEllip(msg, limit)}
          {isExploratory ? " (E)" : ""}
          {isDropped ? " (D)" : ""}
        </span>
      </Tooltip>
      {lowerCasePriority && (
        <Tooltip title={`${priority} Priority`} placement="top-start" arrow>
          <IconButton
            aria-label="priority"
            color={lowerCasePriority === "low" ? "info" : "error"}
            sx={{
              "&.MuiIconButton-root": {
                padding: "0 0 0 5px",
                verticalAlign: "top",
              },
            }}
          >
            {getPriorityIcon(lowerCasePriority)}
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

export default LongMsg;
